"use strict";
// TODO: some day, try to get sub-class attributes explicitly included in IMergedState
// interface IExtra<S> extends Omit<State<S>, 'dispose' | 'get' | 'subscribe' | 'state' | 'setState'> {}
// export type IMergedState<T, S> = IExtra<S> & T;
// type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.State = void 0;
var State = /** @class */ (function () {
    function State(initialState) {
        var _this = this;
        this.subscriptions = [];
        this.setState = function (newState) {
            _this.state = __assign(__assign({}, _this.state), newState);
            _this.publish();
        };
        this.publish = function () {
            _this.subscriptions.forEach(function (sub) { return sub(_this.get()); });
        };
        this.get = function () {
            // eslint-disable-next-line @typescript-eslint/no-unused-vars
            var _a = _this, dispose = _a.dispose, publish = _a.publish, get = _a.get, subscribe = _a.subscribe, subscriptions = _a.subscriptions, state = _a.state, setState = _a.setState, rest = __rest(_a, ["dispose", "publish", "get", "subscribe", "subscriptions", "state", "setState"]);
            return __assign(__assign({}, rest), _this.state);
        };
        this.subscribe = function (callback) {
            _this.subscriptions.push(callback);
            if (_this.state) {
                callback(_this.get());
            }
            return function () {
                remove(callback, _this.subscriptions);
            };
        };
        this.dispose = function () {
            _this.subscriptions = [];
            _this.subscribe = function () {
                throw new Error('Cannot subscribe to a disposed State instance');
            };
        };
        this.state = initialState;
    }
    return State;
}());
exports.State = State;
/**
 * @ignore
 */
function remove(item, array) {
    var index = array.indexOf(item);
    if (index > -1) {
        array.splice(index, 1);
    }
}
//# sourceMappingURL=State.js.map